function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.263 8.189c-5.594 0-10.129 4.539-10.129 10.138 0 4.051 2.393 7.543 5.824 9.166-15.62 5.77-20 4.525-29.458-1.732C2.85 52.796 16.577 55.5 28.51 55.5c11.935 0 20.684-6.11 21.61-13.518.872-6.988-3.9-12.804-10.299-14.615 3.294-1.674 5.571-5.09 5.571-9.04 0-5.6-4.535-10.138-10.129-10.138z",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.717 14.947s5.402 4.056 10.804 2.704c-1.35 5.407-10.804 4.055-10.804 4.055h0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 20a1 1 0 11-2 0 1 1 0 112 0z",
  transform: "matrix(1.35053 0 0 1.35175 -7.954 -12.088)",
  strokeWidth: 0.74,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.861 35.224s-1.35 5.407-16.206 2.703c4.051 13.518 17.557 6.759 17.557 6.759h0",
  strokeLinecap: "round"
}));

var SvgDuck = function SvgDuck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDuck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Duck.8ec04f94.svg";
export { ForwardRef as ReactComponent };